<!-- メニュー -->
<app-menu></app-menu>

<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- 戻る -->
    <div class="return">
      <button
        pButton
        type="button"
        label="マイページ"
        class="p-button-text"
        (click)="moveB301()"
      ></button>
      <button
        pButton
        type="button"
        label="事務局メニュー"
        icon="pi pi-angle-right"
        class="p-button-text"
      ></button>
    </div>

    <!-- タイトル -->
    <div class="title h1-head">
        事務局メニュー
    </div>

    <!-- 審査業務 -->
    <div class="examination-contents">
      <!-- 小タイトル -->
      <div class="examination-title">
        <h1>審査業務</h1>
      </div>

      <div class="examination-note">
        <label
          >未承認の項目がある場合は、各項目をクリックして該当項目の承認作業を行ってください。<br
        /></label>
        <label
          >お問い合わせについては、対応が完了した時点で承認とします。</label
        >
      </div>
      <div class="examination-table">
        <div class="examination-table1">
          <p-table
            [value]="[{}]"
            styleClass="p-datatable-striped"
            responsiveLayout="scroll"
          >
            <ng-template pTemplate="header">
              <tr>
                <th class="examination-icon"></th>
                <th class="item">項目</th>
                <th class="unapproval-no">未承認数</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body">
              <tr class="examination-data">
              <!-- 会員入会審査 -->
                <!-- アイコン -->
                <td  (click)="moveD211()"><i class="pi pi-id-card"></i></td>
                <!-- 項目 -->
                <td class="examination-item-td" (click)="moveD211()" >会員入会審査</td>
                <!-- 未承認数 -->
                <td
                  [class.examination-count-red]="
                    0 != countUnapprovesList?.applicationcount
                  " (click)="moveD211()"
                >
                  {{ countUnapprovesList?.applicationcount }}
                </td>
              </tr>
              <tr class="examination-data">
              <!-- 課題・ソリューション審査 -->
                <!-- アイコン -->
                <td (click)="moveD221()"><i class="pi pi-search"></i></td>
                <!-- 項目 -->
                <td class="examination-item-td" (click)="moveD221()">課題・ソリューション審査</td>
                <!-- 未承認数 -->
                <td
                  [class.examination-count-red]="
                    0 != countUnapprovesList?.agenda_solutioncount
                  " (click)="moveD221()"
                >
                  {{ countUnapprovesList?.agenda_solutioncount }}
                </td>
              </tr>
              <tr class="examination-data">
              <!-- マッチング提案審査 -->
                <!-- アイコン -->
                <td (click)="moveD281()"><i class="pi pi-link"></i></td>
                <!-- 項目 -->
                <td class="examination-item-td" (click)="moveD281()">連携事例審査</td>
                <!-- 未承認数 -->
                <td
                  [class.examination-count-red]="
                    0 != countUnapprovesList?.cooperationcount
                  " (click)="moveD281()"
                >
                  {{ countUnapprovesList?.cooperationcount }}
                </td>
              </tr>
              <tr class="examination-data">
              <!-- 分科会審査 -->
                <!-- アイコン -->
                <td (click)="moveD251()"><i class="pi pi-sitemap"></i></td>
                <!-- 項目 -->
                <td class="examination-item-td" (click)="moveD251()">分科会審査</td>
                <!-- 未承認数 -->
                <td
                  [class.examination-count-red]="
                    0 != countUnapprovesList?.subcommitteecount
                  " (click)="moveD251()"
                >
                  {{ countUnapprovesList?.subcommitteecount }}
                </td>
              </tr>
              <tr class="examination-data">
              <!-- 掲示板コメント審査 -->
                <!-- アイコン -->
                <td (click)="moveD271()"><i class="pi pi-envelope"></i></td>
                <!-- 項目 -->
                <td class="examination-item-td" (click)="moveD271()">NGワード審査</td>
                <!-- 未承認数 -->
                <td
                  [class.examination-count-red]="
                    0 != countUnapprovesList?.boardcount
                  " (click)="moveD271()"
                >
                  {{ countUnapprovesList?.boardcount }}
                </td>
              </tr>
            </ng-template>
          </p-table>
      </div>

      <div class="examination-table2">
        <p-table
        [value]="[{}]"
        styleClass="p-datatable-striped"
        responsiveLayout="scroll"
        >
          <ng-template pTemplate="header">
            <tr>
              <th class="examination-icon"></th>
              <th class="item">項目</th>
              <th class="unapproval-no">未承認数</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body">
            <tr class="examination-data">
            <!-- 会員更新審査 -->
              <!-- アイコン -->
              <td (click)="moveD212()"><i class="pi pi-id-card"></i></td>
              <!-- 項目 -->
              <td class="examination-item-td" (click)="moveD212()">会員更新審査</td>
              <!-- 未承認数 -->
              <td
                [class.examination-count-red]="
                  0 != countUnapprovesList?.membercount
                " (click)="moveD212()"
              >
                {{ countUnapprovesList?.membercount }}
              </td>
            </tr>
            <tr class="examination-data">
            <!-- 提案・依頼審査 -->
              <!-- アイコン -->
              <td (click)="moveD231()"><i class="pi pi-comments"></i></td>
              <!-- 項目 -->
              <td class="examination-item-td" (click)="moveD231()">提案・依頼審査</td>
              <!-- 未承認数 -->
              <td
                [class.examination-count-red]="
                  0 != countUnapprovesList?.suggestcount
                " (click)="moveD231()"
              >
                {{ countUnapprovesList?.suggestcount }}
              </td>
            </tr>
            <tr class="examination-data">
            <!-- イベント・お知らせ審査 -->
              <!-- アイコン -->
              <td (click)="moveD241()"><i class="pi pi-calendar"></i></td>
              <!-- 項目 -->
              <td class="examination-item-td" (click)="moveD241()">イベント・お知らせ審査</td>
              <!-- 未承認数 -->
              <td
                [class.examination-count-red]="
                  0 != countUnapprovesList?.member_eventcount
                " (click)="moveD241()"
              >
                {{ countUnapprovesList?.member_eventcount }}
              </td>
            </tr>
            <tr class="examination-data">
              <!-- 問い合わせ一覧 -->
              <!-- アイコン -->
              <td (click)="moveD261()"><i class="pi pi-envelope"></i></td>
              <!-- 項目 -->
              <td class="examination-item-td" (click)="moveD261()">問い合わせ一覧</td>
              <!-- 未承認数 -->
              <td
                [class.examination-count-red]="
                  0 != countUnapprovesList?.inquirycount
                " (click)="moveD261()"
              >
                {{ countUnapprovesList?.inquirycount }}
              </td>
            </tr>
            <tr class="examination-data">
              <!-- 掲示板通報一覧 -->
              <!-- アイコン -->
              <td (click)="moveD291()"><i class="pi pi-exclamation-triangle"></i></td>
              <!-- 項目 -->
              <td class="examination-item-td" (click)="moveD291()">官民連携チャットルーム通報審査</td>
              <!-- 未承認数 -->
              <td
                [class.examination-count-red]="
                  0 != countUnapprovesList?.message_board_report_count
                " (click)="moveD291()"
              >
                {{ countUnapprovesList?.message_board_report_count }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>

    <!-- マスター登録 -->
    <div class="master-contents">
      <!-- 小タイトル -->
      <div class="master-title">
        <h1>マスター登録</h1>
      </div>

      <p-table
        [value]="[{}]"
        styleClass="p-datatable-striped"
        responsiveLayout="scroll"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="master-icon"></th>
            <th class="master-item">項目</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body">
          <!-- HPの新着・お知らせ・プラットフォーム主催イベント更新 -->
          <tr class="master-data" (click)="moveG101()">
            <!-- アイコン -->
            <td><i class="pi pi-bell"></i></td>
            <!-- 項目 -->
            <td class="master-item-td">
              HPの新着・お知らせ・プラットフォーム主催イベント更新
            </td>
          </tr>
          <!-- HPの事例紹介記事更新 -->
          <tr class="master-data" (click)="moveJ201()">
            <!-- アイコン -->
            <td><i class="pi pi-book"></i></td>
            <!-- 項目 -->
            <td class="master-item-td">
              事例紹介記事更新
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- 解析 -->
    <div class="analysis-contents">
      <!-- 小タイトル -->
      <div class="analysis-title">
        <h1>解析</h1>
      </div>

      <p-table
        [value]="[{}]"
        styleClass="p-datatable-striped"
        responsiveLayout="scroll"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="analysis-icon"></th>
            <th class="analysis-item">項目</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body">
          <!-- ダッシュボード -->
          <tr class="analysis-data" (click)="moveI101()">
            <!-- アイコン -->
            <td><i class="pi pi-chart-bar"></i></td>
            <!-- 項目 -->
            <td class="analysis-item-td">
              ダッシュボード
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- CSVデータダウンロード -->
    <div class="csvdata-contents">
      <!-- 小タイトル -->
      <div class="csvdata-title">
        <h1>CSVデータダウンロード</h1>
      </div>

      <p-table
        [value]="[{}]"
        styleClass="p-datatable-striped"
        responsiveLayout="scroll"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="csvdata-icon"></th>
            <th class="csvdata-item">項目</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body">
          <!-- 会員一覧 -->
          <tr class="csvdata-data" (click)="moveF111()">
            <!-- アイコン -->
            <td><i class="pi pi-download"></i></td>
            <!-- 項目 -->
            <td class="csvdata-item-td">会員一覧</td>
          </tr>
          <!-- 課題・ソリューション -->
          <tr class="csvdata-data" (click)="moveF121()">
            <!-- アイコン -->
            <td><i class="pi pi-download"></i></td>
            <!-- 項目 -->
            <td class="csvdata-item-td">課題・ソリューション</td>
          </tr>
          <!-- 提案一覧 -->
          <tr class="csvdata-data" (click)="moveF131()">
            <!-- アイコン -->
            <td><i class="pi pi-download"></i></td>
            <!-- 項目 -->
            <td class="csvdata-item-td">提案・依頼一覧</td>
          </tr>
          <!-- イベント一覧 -->
          <tr class="csvdata-data" (click)="moveF141()">
            <!-- アイコン -->
            <td><i class="pi pi-download"></i></td>
            <!-- 項目 -->
            <td class="csvdata-item-td">イベント一覧</td>
          </tr>
          <!-- 分科会一覧 -->
          <tr class="csvdata-data" (click)="moveF151()">
            <!-- アイコン -->
            <td><i class="pi pi-download"></i></td>
            <!-- 項目 -->
            <td class="csvdata-item-td">分科会一覧</td>
          </tr>
          <!-- 分科会参加者一覧 -->
          <tr class="csvdata-data" (click)="moveF171()">
            <!-- アイコン -->
            <td><i class="pi pi-download"></i></td>
            <!-- 項目 -->
            <td class="csvdata-item-td">分科会参加者一覧</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
